export default {
  brand: 'USFansLink',
  navSpreadsheet: 'Feuille de calcul',
  navGuides: 'Guides',
  navReviews: 'Avis',
  navShipping: 'Livraison',
  navSafety: 'Sécurité',
  navBlog: 'Blog',
  browseLabel: 'Parcourir les catégories',
  categoryTitle: 'Acheter par catégorie',
  categorySubtitle: 'Accédez directement à la section dont vous avez besoin sur le site principal.',
  visitMain: 'Visiter le site principal',
  buyNow: 'Acheter maintenant',
  usfansSpreadsheet: 'Feuille de calcul USFans',
  language: 'Langue',
  footerTagline: 'Votre centre de ressources indépendant pour les guides de la feuille de calcul USFans, la recherche de produits, les conseils QC et la livraison.',
  footerResources: 'Ressources',
  footerLegal: 'Mentions légales',
  about: 'À propos',
  editorialPolicy: 'Politique éditoriale',
  contact: 'Contact',
  privacyPolicy: 'Politique de confidentialité',
  terms: 'Conditions',
  disclaimer: 'Avertissement',
  disclaimerText: "USFansLink.beauty est une ressource d'information indépendante et n'est ni affiliée à USFans ni approuvée par USFans, sauf mention explicite.",
  navHome: 'Accueil',
  navShoppingGuide: 'Guide d\'achat',
  tagResource: 'Ressource',
  tagReview: 'Avis',
  tagLegit: 'Fiabilité',
  tagShipping: 'Livraison',
  tagWarehouse: 'Entrepôt',
  tagQc: 'QC',
  tagCoupon: 'Coupon',
  tagSeller: 'Vendeur',
  tagSafety: 'Sécurité',
  copyright: '© 2026 USFansLink.beauty. Tous droits réservés.',
  notFoundTitle: 'Article introuvable',
  notFoundText: "L'article que vous recherchez n'existe pas ou a peut-être été déplacé.",
};